import { post } from '@namespace/helpers';

export const activateBsBonus = ({ bonusId }) =>
  post(`/service/prewager/campaigns/${bonusId}/activate`).then(
    ({ status, errorCode }) =>
      status === 'success' ? Promise.resolve(true) : Promise.reject(errorCode)
  );
